import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { DotPhraseTemplatesAdminView } from '../../Charting/DotPhraseTemplates'
import { PageContainer } from '../../Views/PageContainer'
import { EducationChecklistConfigView } from './EducationChecklistConfig'
import { GbsConfigAdminView } from './GbsConfig'
import { ICD10LibraryAdminView } from './ICD10Library'
import { LabFlaggingThresholdsAdminView } from './LabFlaggingThresholds'
import { PregnancyClinicalRationalesView } from './PregnancyClinicalRationale'
import { RevenueCodesAdminView } from './RevenueCodes'
import { SupplyKeywordsAdminView } from './SupplyKeywords'
import { TimeLogConfigAdminView } from './TimeLogConfig'

export const ChartingSettingsView = () => (
  <PageContainer fullHeight noFooter pb={4}>
    <Tabs
      h="100%"
      w="100%"
      isLazy
      display="flex"
      flexDirection="column"
      variant="solid-rounded"
      size="sm"
      colorScheme="green"
      bg="white"
      _dark={{ bg: 'gray.900' }}
      // variant="enclosed"
      mt={2}>
      <TabList
        flexFlow="row wrap"
        borderBottom="1px solid"
        p={2}
        borderColor="gray.200"
        _dark={{ borderColor: 'gray.700' }}>
        <Tab>Clinical Rationale Suggestions</Tab>
        <Tab>ICD-10 Code Library</Tab>
        <Tab>Time Log Configuration</Tab>
        <Tab>CDI Keywords</Tab>
        <Tab>Revenue Codes</Tab>
        <Tab>Lab Flagging Thresholds</Tab>
        <Tab>GBS Thresholds</Tab>
        <Tab>Education Checklist</Tab>
        <Tab>Dot Phrases</Tab>
      </TabList>
      <TabPanels flex={1} minH="0">
        <TabPanel h="100%" p={0}>
          <PregnancyClinicalRationalesView />
        </TabPanel>
        <TabPanel h="100%" p={0}>
          <ICD10LibraryAdminView />
        </TabPanel>
        <TabPanel h="100%" overflowY="auto" p={0}>
          <TimeLogConfigAdminView />
        </TabPanel>
        <TabPanel h="100%" overflowY="auto" p={0}>
          <SupplyKeywordsAdminView />
        </TabPanel>
        <TabPanel h="100%" overflowY="auto" p={0}>
          <RevenueCodesAdminView />
        </TabPanel>
        <TabPanel h="100%" overflowY="auto" p={0}>
          <LabFlaggingThresholdsAdminView />
        </TabPanel>
        <TabPanel h="100%" overflowY="auto" p={0}>
          <GbsConfigAdminView />
        </TabPanel>
        <TabPanel h="100%" overflowY="auto" p={0}>
          <EducationChecklistConfigView />
        </TabPanel>
        <TabPanel h="100%" overflowY="auto" p={0}>
          <DotPhraseTemplatesAdminView />
        </TabPanel>
      </TabPanels>
    </Tabs>
  </PageContainer>
)
